module.exports = __webpack_public_path__ + "static/img/hover-iocn5.97625cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn5.svg
// module id = qFwu
// module chunks = 0